import React, { forwardRef } from 'react';
import { PropTypes } from '../../../utils/propTypes';
import styles from './Input.module.css';

/**
 * Input — the shared 2.0 text input, reimplemented in Athena's idiom (JSX + CSS
 * Module + 2.0 tokens). Values are inlined from the semantic / --ds2-* layer
 * (flat — no --input-* token group); the per-theme box bg + invalid ring use
 * [data-theme="light"] overrides in Input.module.css. Forwards all native props
 * (type incl. "file", disabled, aria-invalid, placeholder, required, …).
 *
 * Preview-only for now (globals.css isn't imported into the app).
 */
const Input = forwardRef(({ type = 'text', className = '', ...props }, ref) => (
  <input
    ref={ref}
    type={type}
    data-slot="input"
    className={`${styles.input} ${className}`.trim()}
    {...props}
  />
));

Input.displayName = 'Input';

Input.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
};

export default Input;
export { Input };
